import { ProductCode, Product } from './types';

export const DBT_ALT_COINS_PRODUCT_CODES = ['OS', 'SF', 'MT', 'MA', 'RP', 'RF', 'HF'];
export const PRODUCT_CODES = [
  // Deribit
  'DO',
  'EH',
  'CF',
  'AZ',
  'SL',
  'SO',
  'OS',
  'SF',
  'MT',
  'MA',
  'RP',
  'RF',
  'HF',
  'BU',
  'EU',
  'AX',
  'TR',
  'HU',
  // Bit.com
  'BO',
  'VT',
  'OJ',
  'GD',
  'BF',
  'ZW',
  'HM',
  'AU',
  // Bybit
  'JB',
  'BE',
  'JC',
  'BX',
  'BB',
  'EF',
  'EO',
  'XR',
  // --- BEGIN GENERATED PRODUCT CONFIG (paradex-codes) ---
  'XA',
  'XB',
  'XC',
  'XD',
  'XE',
  'XF',
  'XG',
  'XH',
  'XI',
  'XJ',
  'XK',
  'XL',
  'XM',
  'XN',
  'XO',
  'XP',
  'XQ',
  'XS',
  'XT',
  'XU',
  'XV',
  'XW',
  'XX',
  'XY',
  'XZ',
  'ZA',
  'ZB',
  'ZC',
  'ZD',
  'ZE',
  'ZF',
  'ZG',
  'ZH',
  'ZI',
  'ZJ',
  'YA',
  'YB',
  'YC',
  'YD',
  // --- END GENERATED PRODUCT CONFIG (paradex-codes) ---
];

export const PRODUCTS_STRICT: {
  [Code in ProductCode]: Product<Code>;
} = {
  // Deribit
  DO: {
    code: 'DO',
    venue: 'DBT',
    kind: 'OPTION',
    currency: 'BTC',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'BTC Option European - DBT',
    longName: 'DO - BTC Option - European - Deribit',
    contractSize: 1,
    contractCurrency: 'BTC',
    quoteCurrency: 'BTC',
    minBlockSize: 25,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
  },
  EH: {
    code: 'EH',
    venue: 'DBT',
    kind: 'OPTION',
    currency: 'ETH',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'ETH Option European - DBT',
    longName: 'EH - ETH Option - European - Deribit',
    contractSize: 1,
    contractCurrency: 'ETH',
    quoteCurrency: 'ETH',
    minBlockSize: 250,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
  },
  CF: {
    code: 'CF',
    venue: 'DBT',
    kind: 'FUTURE',
    currency: 'BTC',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'BTC Future Inverse - DBT',
    longName: 'CF - BTC Future - Inverse - Deribit',
    contractSize: 10,
    contractCurrency: 'USD',
    quoteCurrency: 'USD',
    minBlockSize: 20_000,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
  },
  AZ: {
    code: 'AZ',
    venue: 'DBT',
    kind: 'FUTURE',
    currency: 'ETH',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'ETH Future Inverse - DBT',
    longName: 'AZ - ETH Future - Inverse - Deribit',
    contractSize: 1,
    contractCurrency: 'USD',
    quoteCurrency: 'USD',
    minBlockSize: 100_000,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
  },
  SL: {
    code: 'SL',
    venue: 'DBT',
    currency: 'SOL',
    longName: 'SL - SOL Option - European - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'SOL Option European - DBT',
    kind: 'OPTION',
    minBlockSize: 2_500,
    strategies: 'all',
    contractCurrency: 'SOL',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 1,
    ratioPrecision: 1,
    pricePrecision: 3,
    isDisabled: true,
  },
  SO: {
    code: 'SO',
    venue: 'DBT',
    currency: 'SOL',
    longName: 'SO - SOL Future - Inverse - Deribit',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'SOL Future Inverse - DBT',
    kind: 'FUTURE',
    minBlockSize: 20_000,
    strategies: 'all',
    contractCurrency: 'USD',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 10,
    ratioPrecision: 2,
    pricePrecision: 2,
    isDisabled: true,
  },
  OS: {
    code: 'OS',
    venue: 'DBT',
    currency: 'SOL',
    longName: 'OS - SOL Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'SOL Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    contractCurrency: 'SOL',
    quoteCurrency: 'USDC',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 10,
    ratioPrecision: 1,
    pricePrecision: 1,
    minBlockSize: 1,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: false, // SF (SOL linear future) integrated as hedge counterpart
  },
  MT: {
    code: 'MT',
    venue: 'DBT',
    currency: 'MATIC',
    longName: 'MT - MATIC Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'MATIC Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    contractCurrency: 'MATIC',
    quoteCurrency: 'USDC',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 1000,
    ratioPrecision: 1,
    pricePrecision: 4,
    minBlockSize: 1,
    isDisabled: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  RP: {
    code: 'RP',
    venue: 'DBT',
    currency: 'XRP',
    longName: 'RP - XRP Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'XRP Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'XRP',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 1000,
    ratioPrecision: 1,
    pricePrecision: 4,
    minBlockSize: 1,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: false, // RF (XRP linear future) integrated as hedge counterpart
  },
  SF: {
    code: 'SF',
    venue: 'DBT',
    currency: 'SOL',
    longName: 'SF - SOL Future - Linear - Deribit',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'SOL Future Linear - DBT',
    kind: 'FUTURE',
    minBlockSize: 50_000,
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'SOL',
    minContractIncrement: 1,
    quantityPrecision: 1,
    contractSize: 0.1,
    ratioPrecision: 2,
    pricePrecision: 3,
    isDisabledForOb: true, // not tradable on OB (SOL not enabled for DBT)
  },
  MA: {
    code: 'MA',
    venue: 'DBT',
    currency: 'MATIC',
    longName: 'MA - MATIC Future - Linear - Deribit',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'MATIC Future Linear - DBT',
    kind: 'FUTURE',
    minBlockSize: 200_000,
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'MATIC',
    minContractIncrement: 1,
    quantityPrecision: 2,
    contractSize: 10,
    ratioPrecision: 2,
    pricePrecision: 4,
    isDisabled: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
    isPerpStrategyLegDisabled: true,
  },
  RF: {
    code: 'RF',
    venue: 'DBT',
    currency: 'XRP',
    longName: 'RF - XRP Future - Linear - Deribit',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XRP Future Linear - DBT',
    kind: 'FUTURE',
    minBlockSize: 50_000,
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'XRP',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 10,
    ratioPrecision: 2,
    pricePrecision: 4,
    isDisabledForOb: true, // not tradable on OB (XRP not enabled for DBT)
  },
  HF: {
    code: 'HF',
    venue: 'DBT',
    currency: 'HYPE',
    longName: 'HF - HYPE Future - Linear - Deribit',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'HYPE Future Linear - DBT',
    kind: 'FUTURE',
    minBlockSize: 50_000,
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'HYPE',
    minContractIncrement: 1,
    quantityPrecision: 1,
    contractSize: 0.1,
    ratioPrecision: 2,
    pricePrecision: 3,
    isDisabledForOb: true, // not tradable on OB
  },
  // Deribit USDC linear options (BTC, ETH, AVAX, TRX)
  BU: {
    code: 'BU',
    venue: 'DBT',
    currency: 'BTC',
    longName: 'BU - BTC Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'BTC Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'BTC',
    minContractIncrement: 0.01,
    quantityPrecision: 2,
    contractSize: 1,
    ratioPrecision: 1,
    pricePrecision: 0,
    minBlockSize: 25,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  EU: {
    code: 'EU',
    venue: 'DBT',
    currency: 'ETH',
    longName: 'EU - ETH Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'ETH Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'ETH',
    minContractIncrement: 0.1,
    quantityPrecision: 1,
    contractSize: 1,
    ratioPrecision: 1,
    pricePrecision: 1,
    minBlockSize: 250,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  AX: {
    code: 'AX',
    venue: 'DBT',
    currency: 'AVAX',
    longName: 'AX - AVAX Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'AVAX Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'AVAX',
    minContractIncrement: 100,
    quantityPrecision: 0,
    contractSize: 100,
    ratioPrecision: 1,
    pricePrecision: 4,
    minBlockSize: 2500,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  TR: {
    code: 'TR',
    venue: 'DBT',
    currency: 'TRX',
    longName: 'TR - TRX Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'TRX Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'TRX',
    minContractIncrement: 10000,
    quantityPrecision: 0,
    contractSize: 10000,
    ratioPrecision: 1,
    pricePrecision: 4,
    minBlockSize: 250000,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  HU: {
    code: 'HU',
    venue: 'DBT',
    currency: 'HYPE',
    longName: 'HU - HYPE Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'HYPE Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'HYPE',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 10,
    ratioPrecision: 1,
    pricePrecision: 3,
    minBlockSize: 1500, // Deribit block_trade_min_trade_amount, in base coin (HYPE)
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: false, // HF (HYPE linear perp) integrated as hedge counterpart
  },
  // Bit.com
  GD: {
    code: 'GD',
    currency: 'BCH',
    longName: 'GD - BCH Option - European - Inverse - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'BCH Option European Inverse - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    contractSize: 1,
    contractCurrency: 'BCH',
    minBlockSize: 100,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    quoteCurrency: 'BCH',
    isDisabled: true,
  },
  BO: {
    code: 'BO',
    currency: 'BTC',
    longName: 'BO - BTC Option - European - Inverse - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'BTC Option European Inverse - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    contractSize: 1,
    contractCurrency: 'BTC',
    minBlockSize: 1,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    quoteCurrency: 'BTC',
    isDisabled: true,
  },
  VT: {
    code: 'VT',
    currency: 'ETH',
    longName: 'VT - ETH Option - European - Inverse - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'ETH Option European Inverse - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    contractSize: 1,
    contractCurrency: 'ETH',
    minBlockSize: 20,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    quoteCurrency: 'ETH',
    isDisabled: true,
  },
  OJ: {
    code: 'OJ',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'TON',
    longName: 'OJ - TON Option - European - Linear - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'TON Option European Linear - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    contractCurrency: 'TON',
    strategies: 'all',
    contractSize: 1,
    minBlockSize: 1,
    pricePrecision: 4,
    ratioPrecision: 2,
    quantityPrecision: 0,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  HM: {
    code: 'HM',
    currency: 'BCH',
    longName: 'HM - BCH Future - Inverse - Bit.com',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'BCH Future Inverse - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 5_000,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
    isDisabled: true,
  },
  BF: {
    code: 'BF',
    currency: 'BTC',
    longName: 'BF - BTC Future - Inverse - Bit.com',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'BTC Future Inverse - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractSize: 10,
    contractCurrency: 'USD',
    minBlockSize: 500,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
    isDisabled: true,
  },
  ZW: {
    code: 'ZW',
    currency: 'ETH',
    longName: 'ZW - ETH Future - Inverse - Bit.com',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'ETH Future Inverse - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 5_000,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
    isDisabled: true,
  },
  BD: {
    code: 'BD',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'BTC',
    longName: 'BD - BTC Option - European - Linear - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'BTC Option European Linear - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    contractSize: 1,
    contractCurrency: 'BTC',
    strategies: 'all',
    minContractIncrement: 0.01,
    minBlockSize: 0.01,
    pricePrecision: 0,
    quantityPrecision: 2,
    ratioPrecision: 1,
    quoteCurrency: 'USD',
  },
  WV: {
    code: 'WV',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'ETH',
    longName: 'WV - ETH Option - European - Linear - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'ETH Option European Linear - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    strategies: 'all',
    contractSize: 1,
    contractCurrency: 'ETH',
    minContractIncrement: 0.1,
    minBlockSize: 0.1,
    quantityPrecision: 1,
    pricePrecision: 0,
    ratioPrecision: 1,
    quoteCurrency: 'USD',
  },
  PE: {
    code: 'PE',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'BTC',
    longName: 'PE - BTC Future - Linear - Bit.com',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BTC Future Linear - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'BTC',
    strategies: 'all',
    minContractIncrement: 0.01,
    minBlockSize: 0.01,
    quantityPrecision: 2,
    pricePrecision: 1,
    ratioPrecision: 1,
    quoteCurrency: 'USD',
  },
  DE: {
    code: 'DE',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'ETH',
    longName: 'DE - ETH Future - Linear - Bit.com',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ETH Future Linear - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'ETH',
    strategies: 'all',
    minContractIncrement: 0.1,
    minBlockSize: 0.1,
    pricePrecision: 2,
    quantityPrecision: 1,
    ratioPrecision: 1,
    quoteCurrency: 'USD',
  },
  AU: {
    code: 'AU',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'TON',
    longName: 'AU - TON Future - Linear - Bit.com',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'TON Future Linear - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractCurrency: 'TON',
    strategies: 'all',
    contractSize: 1,
    minBlockSize: 1,
    pricePrecision: 3,
    ratioPrecision: 2,
    quantityPrecision: 0,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  // Bybit
  BE: {
    code: 'BE',
    isDisabled: true, // Bybit inverse options have no discovery job; never populate
    currency: 'BTC',
    longName: 'BE - BTC Option - European - ByBit',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'BTC Option European - BYB',
    venue: 'BYB',
    kind: 'OPTION',
    contractCurrency: 'BTC',
    strategies: 'all',
    isHedgeDisabled: true,
    contractSize: 1,
    quantityPrecision: 2,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    minBlockSize: 0.01,
    quoteCurrency: 'USDC',
  },
  JB: {
    code: 'JB',
    currency: 'SOL',
    longName: 'JB - SOL Option - European - ByBit',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'SOL Option European - BYB',
    venue: 'BYB',
    kind: 'OPTION',
    contractCurrency: 'SOL',
    strategies: 'all',
    isHedgeDisabled: true,
    contractSize: 1,
    quantityPrecision: 0,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 1,
    minBlockSize: 1,
    quoteCurrency: 'USD',
    isDisabled: true,
  },
  JC: {
    code: 'JC',
    isDisabled: true, // Bybit inverse options have no discovery job; never populate
    currency: 'ETH',
    longName: 'JC - ETH Option - European - ByBit',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'ETH Option European - BYB',
    venue: 'BYB',
    kind: 'OPTION',
    contractCurrency: 'ETH',
    strategies: 'all',
    isHedgeDisabled: true,
    contractSize: 1,
    quantityPrecision: 1,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    minBlockSize: 0.1,
    quoteCurrency: 'USDC',
  },
  BX: {
    code: 'BX',
    currency: 'BTC',
    longName: 'BX - BTC Future - Linear - ByBit',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BTC Future Linear - BYB',
    venue: 'BYB',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'BTC',
    minBlockSize: 0.001,
    minContractIncrement: 0.001,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 3,
    ratioPrecision: 2,
    quoteCurrency: 'USD',
    isDisabled: true,
  },
  BB: {
    code: 'BB',
    currency: 'BTC',
    longName: 'BB - BTC Future - Inverse - ByBit',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'BTC Future Inverse - BYB',
    venue: 'BYB',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 1,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  EF: {
    code: 'EF',
    currency: 'ETH',
    longName: 'EF - ETH Future - Inverse - ByBit',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'ETH Future Inverse - BYB',
    venue: 'BYB',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 1,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  EO: {
    code: 'EO',
    currency: 'EOS',
    longName: 'EO - EOS Future - Inverse - ByBit',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'EOS Future Inverse - BYB',
    venue: 'BYB',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 1,
    strategies: ['Future'],
    quantityPrecision: 0,
    pricePrecision: 3,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  XR: {
    code: 'XR',
    currency: 'XRP',
    longName: 'XR - XRP Future - Inverse - ByBit',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'XRP Future Inverse - BYB',
    venue: 'BYB',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 1,
    strategies: ['Future'],
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  // --- BEGIN GENERATED PRODUCT CONFIG (paradex-products) ---
  XA: {
    code: 'XA',
    venue: 'PRDX',
    kind: 'OPTION',
    currency: 'BTC',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'BTC Option Linear - PRDX',
    longName: 'XA - BTC Option - European - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'BTC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.001,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
  },
  XB: {
    code: 'XB',
    venue: 'PRDX',
    kind: 'OPTION',
    currency: 'ETH',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'ETH Option Linear - PRDX',
    longName: 'XB - ETH Option - European - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ETH',
    quoteCurrency: 'USDC',
    minBlockSize: 0.1,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
  },
  XC: {
    code: 'XC',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'BTC',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BTC Future Linear - PRDX',
    longName: 'XC - BTC Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'BTC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.0001,
    strategies: 'all',
    quantityPrecision: 4,
    pricePrecision: 1,
    ratioPrecision: 1,
    minContractIncrement: 0.0001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XD: {
    code: 'XD',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ETH',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ETH Future Linear - PRDX',
    longName: 'XD - ETH Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ETH',
    quoteCurrency: 'USDC',
    minBlockSize: 0.01,
    strategies: 'all',
    quantityPrecision: 4,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.0001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XE: {
    code: 'XE',
    venue: 'PRDX',
    kind: 'OPTION',
    currency: 'HYPE',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'HYPE Option Linear - PRDX',
    longName: 'XE - HYPE Option - European - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'HYPE',
    quoteCurrency: 'USDC',
    minBlockSize: 1,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
  },
  XF: {
    code: 'XF',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'HYPE',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'HYPE Future Linear - PRDX',
    longName: 'XF - HYPE Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'HYPE',
    quoteCurrency: 'USDC',
    minBlockSize: 0.5,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XG: {
    code: 'XG',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'SOL',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'SOL Future Linear - PRDX',
    longName: 'XG - SOL Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'SOL',
    quoteCurrency: 'USDC',
    minBlockSize: 0.2,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XH: {
    code: 'XH',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XAG',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XAG Future Linear - PRDX',
    longName: 'XH - XAG Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XAG',
    quoteCurrency: 'USDC',
    minBlockSize: 0.2,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XI: {
    code: 'XI',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'CL',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'CL Future Linear - PRDX',
    longName: 'XI - CL Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'CL',
    quoteCurrency: 'USDC',
    minBlockSize: 0.2,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XJ: {
    code: 'XJ',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'BNB',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BNB Future Linear - PRDX',
    longName: 'XJ - BNB Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'BNB',
    quoteCurrency: 'USDC',
    minBlockSize: 0.02,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XK: {
    code: 'XK',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'PAXG',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'PAXG Future Linear - PRDX',
    longName: 'XK - PAXG Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'PAXG',
    quoteCurrency: 'USDC',
    minBlockSize: 0.003,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XL: {
    code: 'XL',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XRP',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XRP Future Linear - PRDX',
    longName: 'XL - XRP Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XRP',
    quoteCurrency: 'USDC',
    minBlockSize: 10,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XM: {
    code: 'XM',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ZEC',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ZEC Future Linear - PRDX',
    longName: 'XM - ZEC Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ZEC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.03,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XN: {
    code: 'XN',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'LIT',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'LIT Future Linear - PRDX',
    longName: 'XN - LIT Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'LIT',
    quoteCurrency: 'USDC',
    minBlockSize: 10,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XO: {
    code: 'XO',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ADA',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ADA Future Linear - PRDX',
    longName: 'XO - ADA Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ADA',
    quoteCurrency: 'USDC',
    minBlockSize: 65,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XP: {
    code: 'XP',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'NEAR',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'NEAR Future Linear - PRDX',
    longName: 'XP - NEAR Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'NEAR',
    quoteCurrency: 'USDC',
    minBlockSize: 5,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XQ: {
    code: 'XQ',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XPT',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XPT Future Linear - PRDX',
    longName: 'XQ - XPT Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XPT',
    quoteCurrency: 'USDC',
    minBlockSize: 0.006,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 1,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XS: {
    code: 'XS',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XCU',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XCU Future Linear - PRDX',
    longName: 'XS - XCU Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XCU',
    quoteCurrency: 'USDC',
    minBlockSize: 2,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XT: {
    code: 'XT',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'BZ',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BZ Future Linear - PRDX',
    longName: 'XT - BZ Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'BZ',
    quoteCurrency: 'USDC',
    minBlockSize: 0.2,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XU: {
    code: 'XU',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'SUI',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'SUI Future Linear - PRDX',
    longName: 'XU - SUI Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'SUI',
    quoteCurrency: 'USDC',
    minBlockSize: 15,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XV: {
    code: 'XV',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'LINK',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'LINK Future Linear - PRDX',
    longName: 'XV - LINK Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'LINK',
    quoteCurrency: 'USDC',
    minBlockSize: 1.5,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XW: {
    code: 'XW',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'TAO',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'TAO Future Linear - PRDX',
    longName: 'XW - TAO Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'TAO',
    quoteCurrency: 'USDC',
    minBlockSize: 0.05,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XX: {
    code: 'XX',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ASTER',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ASTER Future Linear - PRDX',
    longName: 'XX - ASTER Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ASTER',
    quoteCurrency: 'USDC',
    minBlockSize: 20,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XY: {
    code: 'XY',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'PENDLE',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'PENDLE Future Linear - PRDX',
    longName: 'XY - PENDLE Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'PENDLE',
    quoteCurrency: 'USDC',
    minBlockSize: 10,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XZ: {
    code: 'XZ',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'WLFI',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'WLFI Future Linear - PRDX',
    longName: 'XZ - WLFI Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'WLFI',
    quoteCurrency: 'USDC',
    minBlockSize: 200,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZA: {
    code: 'ZA',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'PYTH',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'PYTH Future Linear - PRDX',
    longName: 'ZA - PYTH Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'PYTH',
    quoteCurrency: 'USDC',
    minBlockSize: 300,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZB: {
    code: 'ZB',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'HYPER',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'HYPER Future Linear - PRDX',
    longName: 'ZB - HYPER Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'HYPER',
    quoteCurrency: 'USDC',
    minBlockSize: 150,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZC: {
    code: 'ZC',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'DOGE',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'DOGE Future Linear - PRDX',
    longName: 'ZC - DOGE Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'DOGE',
    quoteCurrency: 'USDC',
    minBlockSize: 150,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZD: {
    code: 'ZD',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XLM',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XLM Future Linear - PRDX',
    longName: 'ZD - XLM Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XLM',
    quoteCurrency: 'USDC',
    minBlockSize: 50,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZE: {
    code: 'ZE',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'LDO',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'LDO Future Linear - PRDX',
    longName: 'ZE - LDO Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'LDO',
    quoteCurrency: 'USDC',
    minBlockSize: 40,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZF: {
    code: 'ZF',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'LTC',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'LTC Future Linear - PRDX',
    longName: 'ZF - LTC Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'LTC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.25,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZG: {
    code: 'ZG',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ONDO',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ONDO Future Linear - PRDX',
    longName: 'ZG - ONDO Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ONDO',
    quoteCurrency: 'USDC',
    minBlockSize: 30,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZH: {
    code: 'ZH',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'MON',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'MON Future Linear - PRDX',
    longName: 'ZH - MON Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'MON',
    quoteCurrency: 'USDC',
    minBlockSize: 500,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 6,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZI: {
    code: 'ZI',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'PENGU',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'PENGU Future Linear - PRDX',
    longName: 'ZI - PENGU Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'PENGU',
    quoteCurrency: 'USDC',
    minBlockSize: 1600,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 6,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZJ: {
    code: 'ZJ',
    venue: 'PRDX',
    kind: 'OPTION',
    currency: 'ZEC',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'ZEC Option Linear - PRDX',
    longName: 'ZJ - ZEC Option - European - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ZEC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.1,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
  },
  YA: {
    code: 'YA',
    venue: 'BLSH',
    kind: 'OPTION',
    currency: 'BTC',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'BTC Option Linear - BLSH',
    longName: 'YA - BTC Option - European - Linear - Bullish',
    contractSize: 1,
    contractCurrency: 'BTC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.0005,
    strategies: 'all',
    quantityPrecision: 4,
    pricePrecision: 0,
    ratioPrecision: 1,
    minContractIncrement: 0.0005,
    isNew: true,
    isDisabledForOb: true,
  },
  YB: {
    code: 'YB',
    venue: 'BLSH',
    kind: 'OPTION',
    currency: 'ETH',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'ETH Option Linear - BLSH',
    longName: 'YB - ETH Option - European - Linear - Bullish',
    contractSize: 1,
    contractCurrency: 'ETH',
    quoteCurrency: 'USDC',
    minBlockSize: 0.005,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 0,
    ratioPrecision: 1,
    minContractIncrement: 0.005,
    isDisabled: true,
    isDisabledForOb: true,
  },
  YC: {
    code: 'YC',
    venue: 'BLSH',
    kind: 'FUTURE',
    currency: 'BTC',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BTC Future Linear - BLSH',
    longName: 'YC - BTC Future - Linear - Bullish',
    contractSize: 1,
    contractCurrency: 'BTC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.0001,
    strategies: 'all',
    quantityPrecision: 4,
    pricePrecision: 1,
    ratioPrecision: 1,
    minContractIncrement: 0.0001,
    isNew: true,
    isDisabledForOb: true,
  },
  YD: {
    code: 'YD',
    venue: 'BLSH',
    kind: 'FUTURE',
    currency: 'ETH',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ETH Future Linear - BLSH',
    longName: 'YD - ETH Future - Linear - Bullish',
    contractSize: 1,
    contractCurrency: 'ETH',
    quoteCurrency: 'USDC',
    minBlockSize: 0.005,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.005,
    isNew: true,
    isDisabled: true,
    isDisabledForOb: true,
  },
  // --- END GENERATED PRODUCT CONFIG (paradex-products) ---
};

export const PRODUCTS: Readonly<Record<string, Product>> = PRODUCTS_STRICT;
